<template lang="pug">
#live-stream-modal.modal-card
  header.modal-card-head
    p.modal-card-title Watch our services live
  section.modal-card-body
    p Since we do not stream the worship portion of our services, the live stream will begin approximately half an hour after the scheduled start time.
  .modal-card-table
    b-table(
      :data="services"
      :mobile-cards="false"
    )
      template(slot-scope="props")
        b-table-column(label="Service" :visible="!isMobile") {{ props.row.title }}
        b-table-column(label="Day") {{ props.row.weekday }}
        b-table-column(label="Start Time" :numeric="isMobile") {{ props.row.start_time | date('h:mm A') }}
  footer.modal-card-foot
    a.button.is-primary(
      v-if="account.social.youtube"
      :href="account.social.youtube"
      target="_blank"
    )
      b-icon(icon="youtube")
      span Watch on YouTube
    a.button.is-primary(
      v-if="account.social.facebook"
      :href="account.social.facebook"
      target="_blank"
    )
      b-icon(icon="facebook")
      span Watch on Facebook
</template>

<script>
import { mapGetters } from 'vuex';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'live-stream-modal',
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      services: getterTypes.GET_SERVICES,
    }),
    isMobile() {
      return window.innerWidth <= 769;
    },
  },
};
</script>

<style lang="scss">
#live-stream-modal {
  table.table {
    tr {
      th, td {
        border: none;
        &:first-child {
          padding-left: 20px;
        }
        &:last-child {
          padding-right: 20px;
        }
      }
    }
  }
}
@media (min-width: $desktop) {
  #live-stream-modal {
    .modal-card-foot {
      justify-content: center;
    }
  }
}
@media (max-width: $tablet) {
  #live-stream-modal {
    padding: 0 1.5rem;
    table.table {
      tr {
        th, td {
          &:last-child {
            width: 120px;
          }
        }
      }
    }
    .modal-card-foot {
      flex-flow: column;
      justify-content: center;
      .button:not(:last-child) {
        margin-right: 0;
      }
      .button + .button {
        margin-top: 0.75rem;
      }
    }
  }
}
</style>
